import useEntityDetailsRedirectLink from './hooks/useRedirectLink';
import Loading from '../../components/Loading';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 The {@link EntityDetailsShow} screen requires an entity to have been selected

 In some flows, we would like to able to link a user to an entity app and select
 the first entity value available.

 This screen serves that purpose by doing the networking to determine what
 that first entity is and then redirecting the user to the EntityDetailsShow
 screen when ready.

 We will show a spinner while we wait.
*/
const EntityDetailsShowRedirect = () => {
  const redirectLink = useEntityDetailsRedirectLink();
  const navigate = useNavigate();

  useEffect(() => {
    if (!redirectLink) {
      return;
    }

    navigate(redirectLink);
  }, [navigate, redirectLink]);

  return <Loading />;
};

export default EntityDetailsShowRedirect;
